<snelstart-ui-details
  [config]="detailsConfig"
  [entityId]="id"
  title="{{this.titelMachtiging}}"
>

  <snelstart-ui-details-content>
    <snelstart-venture-fiscaal-muma [id]="id"></snelstart-venture-fiscaal-muma>
  </snelstart-ui-details-content>

  <snelstart-ui-details-buttons>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [disabled]="!this.isOpvoeren"
                         [config]="configOpvoeren()">Aanvragen
    </snelstart-ui-button>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [disabled]="!this.isIntrekken"
                         (click)="showDeleteInfo()">Intrekken
    </snelstart-ui-button>
    <snelstart-ui-button type="primary"
                         class="me-2"
                         [disabled]="!this.isActiveren"
                         [config]="configActiveren()">Activeren
    </snelstart-ui-button>
    <ng-container *ngIf="this.machtigingBevatViaMachtiging()">
      <snelstart-ui-button type="primary"
                           class="me-2"
                           [disabled]="!this.viaOphalenIsEnabled()"
                           [config]="configViaOphalen()">Via-gegevens ophalen
      </snelstart-ui-button>
    </ng-container>
  </snelstart-ui-details-buttons>
</snelstart-ui-details>

<snelstart-ui-dialog></snelstart-ui-dialog>

<snelstart-ui-dialog-definition id="delete"
                                title="Intrekken machtiging bij Digipoort" size="md"
                                [(visible)]="dialogDelete">
  <snelstart-ui-dialog-body>
    <div class="d-flex pt-1 pb-1">
      Weet je zeker dat je machtiging wilt intrekken?
    </div>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button id="delete2" type="secondary" icon="xmark" btn-x>Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button class="ps-3" id="delete1" type="danger" icon="check" [config]="configIntrekken()">
      Ja, machtiging intrekken
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

